/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateScanMetaData } from './CreateScanMetaData';
export type CreateScanData = {
    /**
     * Right size preferences of the user.
     */
    subtype: CreateScanData.subtype;
    /**
     * Scan metadata.
     */
    metaData: CreateScanMetaData;
    /**
     * scan binary encoded to base64
     */
    scan: string;
};
export namespace CreateScanData {
    /**
     * Right size preferences of the user.
     */
    export enum subtype {
        SCAN_SUBTYPE_FLAT_LEFT_FOOT = 'SCAN_SUBTYPE_FLAT_LEFT_FOOT',
        SCAN_SUBTYPE_FLAT_RIGHT_FOOT = 'SCAN_SUBTYPE_FLAT_RIGHT_FOOT',
    }
}

